/**
 * @generated SignedSource<<33d0734dbecd0532f4cdc6530410cd99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsAppSetupModalFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "EventsAppSetupModalFragment";
};
export type EventsAppSetupModalFragment$key = {
  readonly " $data"?: EventsAppSetupModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventsAppSetupModalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventsAppSetupModalFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};

(node as any).hash = "8bbc6033be994228ed4ca9747f8aeeb7";

export default node;
